import { FTSocket } from './socket';
import { API_URL } from 'utils/constants';

const Gravemind = new FTSocket(API_URL);
export default Gravemind;
